export const EXPERIENCES = {
  EXP_REVIEW_PAGE: 'exp-review-page',
  EXP_DIRECT_CHECKOUT: 'exp-direct-checkout',
  USER_EXPERIENCE_INITIATED: 'user-experience-initiated',
} as const
export type Experiences = (typeof EXPERIENCES)[keyof typeof EXPERIENCES]

export const EXPERIENCE_ANALYTICS = {
  EXP_REVIEW_PAGE_DEFAULT: 'exp-review-page-default',
  EXP_REVIEW_PAGE_HIDDEN: 'exp-review-page-hidden',
  EXP_DIRECT_CHECKOUT_DEFAULT: 'exp-direct-checkout-default',
  EXP_DIRECT_CHECKOUT_ENABLED: 'exp-direct-checkout-enabled',
}

export const EXPERIENCE_VARIANTS = {
  DEFAULT: 'DEFAULT',
  HIDDEN: 'HIDDEN',
  ENABLED: 'ENABLED',
}
